import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { ChatType } from 'src/shared/schemas/chats/chat-data'

const getChatChannels = async (query = '', types: ChatType[]): Promise<string[] | undefined> => {
  const formattedTypes = types.map((type) => type.replace(/-/g, '_'))
  const params = new URLSearchParams()
  params.append('query', query)
  formattedTypes.forEach((type) => params.append('types', type))
  const response = await getRequest<string[]>(`/feeds/channel-ids?${params.toString()}`)

  if (!response || response.length === 0) {
    return ['messaging:fake-cid']
  }
  return response
}

export const useChatChannels = (query = '', types: ChatType[] = []) => {
  return useQuery({
    queryKey: queries.chats.channels(query, types).queryKey,
    queryFn: () => getChatChannels(query, types),
    retry: false,
    staleTime: 10,
  })
}
